import { Bill, ToBillArguments, ToBillEvent } from "../../../models/Factura";
import { ProfileQL } from "../../../models/Profile";
import { paymentRequestFactory, upfrontBillFactory } from "../../../services/calculations.cfdi";
import { calculateTotal } from "../../../utils/calculate.conceptos";


export const structureBillArgumentsToBillEvents = (currentUser: ProfileQL, billArgument: ToBillArguments<ToBillEvent>, masterCfdi: Bill) => {
    const billEvents: ToBillEvent[] = [];
    const paymentEvents: ToBillEvent[] = [];
    const { total } = calculateTotal(masterCfdi.conceptos);
    billArgument.billEvents = [];
    billArgument.paymentEvents = [];
    billArgument.MasterCFDI = masterCfdi;
    if (billArgument.multipayType === 0) {
        if (masterCfdi.metodoPago === 'PUE') {
            // Do nothing
        } else {
            const toPaymentEvents = paymentRequestFactory({
                upfront: 0,
                total,
                lugarExpedicion: currentUser.fiscalpopProfile.lugarExpedicion,
                receptor: {
                    nombre: masterCfdi.receptor.nombre,
                    rfc: masterCfdi.receptor.rfc,
                    usoCFDI: 'P01',
                    email: masterCfdi.receptor.email || null
                },
                frequency: billArgument.frequency,
                multiPayments: billArgument.multiPayments,
                timeDefered: billArgument.timeDefered
            })
            for (const e of toPaymentEvents) {
                paymentEvents.push(e);
            }
        }
    } else if (billArgument.multipayType === 1) {
        if (masterCfdi.metodoPago === 'PUE') {
            const upfrontEvents = upfrontBillFactory({
                upfront: billArgument.upfront,
                timeDefered: billArgument.timeDefered,
                masterCfdi: masterCfdi,
            });
            billArgument.MasterCFDI = upfrontEvents.adelantoBill;
            billEvents.push(upfrontEvents.billEvents[0]);
        } else {
            const toPaymentEvents = paymentRequestFactory({
                upfront: billArgument.upfront,
                total,
                lugarExpedicion: currentUser.fiscalpopProfile.lugarExpedicion,
                receptor: {
                    nombre: masterCfdi.receptor.nombre,
                    rfc: masterCfdi.receptor.rfc,
                    usoCFDI: 'P01',
                    email: masterCfdi.receptor.email || null
                },
                frequency: billArgument.frequency,
                multiPayments: billArgument.multiPayments,
                timeDefered: billArgument.timeDefered
            })
            for (const e of toPaymentEvents) {
                paymentEvents.push(e);
            }
        }
    } else if (billArgument.multipayType === 2) {
        const toPaymentEvents = paymentRequestFactory({
            upfront: billArgument.upfront,
            total,
            lugarExpedicion: currentUser.fiscalpopProfile.lugarExpedicion,
            receptor: {
                nombre: masterCfdi.receptor.nombre,
                rfc: masterCfdi.receptor.rfc,
                usoCFDI: 'P01',
                email: masterCfdi.receptor.email || null
            },
            frequency: billArgument.frequency,
            multiPayments: billArgument.multiPayments,
            timeDefered: billArgument.timeDefered
        })
        for (const e of toPaymentEvents) {
            paymentEvents.push(e);
        }
    } else if (billArgument.multipayType === 3) {
        const toPaymentEvents = paymentRequestFactory({
            upfront: billArgument.upfront,
            total,
            lugarExpedicion: currentUser.fiscalpopProfile.lugarExpedicion,
            receptor: {
                nombre: masterCfdi.receptor.nombre,
                rfc: masterCfdi.receptor.rfc,
                usoCFDI: 'P01',
                email: masterCfdi.receptor.email || null
            },
            frequency: billArgument.frequency,
            multiPayments: billArgument.multiPayments,
            timeDefered: billArgument.timeDefered
        })
        for (const e of toPaymentEvents) {
            paymentEvents.push(e);
        }
    }

    // General settings
    if (billArgument.timeDefered === 0) {
        billArgument.isClosed = true;
    } else {
        billArgument.isClosed = false;
    }
    billArgument.createdAt = Date.now();
    return {
        billArgument,
        billEvents,
        paymentEvents
    }
}